/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-15 16:19:58
 * @LastEditTime: 2020-08-16 10:26:29
 * @Description: 车辆信息api
 */
import axios from '@/utils/axios'

export const getVehicleList = (payload) => {
    return axios.get('/vehicle', {
        params: payload
    })
}

export const getVehicleByID = (id) => {
    return axios.get(`/vehicle/${id}`)
}

export const updateVehicle = (id, data) => {
    return axios.put(`/vehicle/${id}`, data)
}

export const createVehicle = (data) => {
    return axios.post(`/vehicle`, data)
}

export const deleteVehicle = (id) => {
    return axios.delete(`/vehicle/${id}`)
}